import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const uploadFilesFromRequest = async (
  dispatch: Dispatch,
  data: any,
  requesData: any,
) => {
  const { requestId, requestType } = requesData;
  const response = await requestHandler({
    method: 'patch',
    url: `internal/files/requestType/${requestType}/requestId/${requestId}`,
    data,
    headers: {},
    dispatch,
  });
  if (response) return response.data;
};

export const downloadFilesFromRequest = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/files/requestType/${data.requestType}/requestId/${data.requestId}/file/${data.fileName}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getFileAsBlobFromRequest = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/files/requestType/${data.requestType}/requestId/${data.requestId}/file/${data.fileName}/blob`,
    dispatch,
    responseType: 'blob',
  });
  if (response) {
    return {
      blob: response.data,
      contentType: response.headers['content-type'],
    };
  }
  return null;
};

export const getFilesFromRequest = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/files/requestType/${data.requestType}/requestId/${data.requestId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateFileNameFromRequest = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/files/requestType/${data.requestType}/requestId/${data.requestId}/name`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteFileFromRequest = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/files/requestType/${data.requestType}/requestId/${data.requestId}/file/${data.fileName}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getRequiredFiles = async (
  dispatch: Dispatch,
  requestType: string,
  requestId: string | undefined,
  names: string[],
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/files/requestType/${requestType}/requestId/${requestId}/requiredFiles/${names.join(',')}`,
    dispatch,
  });
  if (response) return response.data;
};
